import { AdminAdvisorErrorBoundary } from '@/components/admin-advisor/admin-advisor-error-boundary';
import { AdminAdvisorPanel } from '@/components/admin-advisor/admin-advisor-panel';
import { AdminAgentSideTab } from '@/components/admin-advisor/admin-agent-side-tab';

export function AdminAdvisorChrome() {
  return (
    <>
      <AdminAdvisorErrorBoundary>
        <AdminAdvisorPanel />
      </AdminAdvisorErrorBoundary>
      <AdminAgentSideTab />
    </>
  );
}
